import type { ProviderProps } from "react";
import type { ChipProps } from "@mui/material/Chip";

export const enum Fields {
    RequestedChange = 'requestedChangeFields',
    Statuses = 'fieldsStatuses',
    Comments = 'fieldsComments'
};

export const enum FieldStatus {
    Approved = 'approved',
    AwaitingReview = 'awaiting_review',
    Rejected = 'rejected',
    RequestedChanges = 'requested_changes'
};

export const fieldStatusStyleMap = new Map<
    FieldStatus,
    Pick<ChipProps, 'label' | 'color'>
>([
    [FieldStatus.Approved, {
        color: 'success' as const,
        label: 'Approved'
    }],
    [FieldStatus.AwaitingReview, {
        color: 'warning' as const,
        label: 'Awaiting Review'
    }],
    [FieldStatus.Rejected, {
        color: 'error' as const,
        label: 'Rejected'
    }],
    [FieldStatus.RequestedChanges, {
        color: 'secondary' as const,
        label: 'Requested Changes'
    }]
]);

export interface Config {
    readonly fieldStatusStyleMap: Map<
        FieldStatus,
        Pick<ChipProps, 'label' | 'color'>
    >;

    readonly FieldsComments: Fields;

    readonly FieldsStatuses: Fields;

    readonly RequestedChangeFields: Fields;

    readonly FieldStatusRejected: FieldStatus;

    readonly FieldStatusApproved: FieldStatus;

    readonly FieldStatusAwaitingReview: FieldStatus;

    readonly FieldStatusRequestedChanges: FieldStatus;
}

export type ConfigProviderProps = ProviderProps<Config>;

export type WithConfigProps<TProps extends object = {}> = TProps & {
    readonly config?: ConfigProviderProps['value'];
};
